export default "__VITE_ASSET__CVIwjr6q__"